/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListAffiliateReferrersOptions,
  ListAffiliateReferrersResponses,
} from '../types/ListAffiliateReferrers'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description ADMIN, INTEGRATOR, or AFFILIATE_MANAGER required within the same tenant and assigned-program scope as disabling. Active memberships only by default; include_disabled=true also returns disabled memberships. Includes memberships in paused programs. Includes every issued referral code with current and active indicators. Pagination counts referrers, not codes. Code-edit permissions are unchanged.
 * @summary List program referrers
 * {@link /v1/affiliate_programs/:program_id/referrers}
 */
export function listAffiliateReferrers<ThrowOnError extends boolean = true>(
  options: Options<ListAffiliateReferrersOptions, ThrowOnError>,
): Unwrappable<RequestResult<ListAffiliateReferrersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/affiliate_programs/{program_id}/referrers',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListAffiliateReferrersResponses, ThrowOnError>>,
  )
}
